import {msg} from '@lingui/core/macro'
import {useLingui} from '@lingui/react'

import {useTheme} from '#/alf'
import {CircleCheck_Stroke2_Corner0_Rounded as CircleCheck} from '#/components/icons/CircleCheck'
import * as Pills from '#/components/Pills'
import * as Prompt from '#/components/Prompt'

/**
 * Pill shown on posts where the author self-applied an adult content label,
 * to make it clear the disclosure came from the author rather than a
 * moderator - see [[UndisclosedAdultContentPill]] for the opposite case.
 * Gated behind `UNDISCLOSED_ADULT_CONTENT_BADGE_ENABLED` by the caller.
 */
export function AuthorLabeledAdultContentPill({
  size,
}: {
  size?: Pills.CommonProps['size']
}) {
  const t = useTheme()
  const {_} = useLingui()
  const control = Prompt.usePromptControl()

  return (
    <>
      <Pills.LabelBase
        label={_(msg`The author labeled this post as adult content`)}
        cta={_(msg`Author Labeled`)}
        size={size}
        noBg={size === 'sm'}
        icon={
          <CircleCheck
            width={size === 'lg' ? 16 : 12}
            fill={t.palette.positive_500}
          />
        }
        onPress={() => control.open()}
      />
      <Prompt.Basic
        control={control}
        title={_(msg`Author labeled`)}
        description={_(
          msg`The author of this post marked it with an adult content warning themselves.`,
        )}
        confirmButtonCta={_(msg`Got it`)}
        onConfirm={() => {}}
        showCancel={false}
      />
    </>
  )
}
